import { TYPE_OF_VEHICLES } from '@/pages/Inspection/utils/contants'
import { ETipoFotoVistoria } from '@/types/enums/parametrization'
import { IPhotoFlowSection, IPhotoFlowTemp } from '@/types/photoFlow.types'

export function getIdByName(name: string, arr: any[]) {
  if (!name || !arr?.length) return ''

  const finder = arr.find(
    (item) =>
      item.nome === name ||
      item.nomeFantasia === name ||
      `${item?.nome} - ${item?.codigoFipe}` === name ||
      item.descricao === name,
  )
  const id = finder && finder.id ? finder.id : ''
  return id
}

export function getByName(arr: any[]) {
  if (!arr?.length) return

  return arr.map((item) => item.nome)
}

export function getNameById(id: string, arr: any[]) {
  if (!id || !arr?.length) return ''
  const finder = arr.find((item) => item.id === id)
  return finder?.nome
}

export function getCNPJByName(name: string, arr: any[]) {
  if (!name || !arr) return ''

  const finder = arr.find(
    (item) => item.nome === name || item.razaoSocial === name || item.nomeFantasia === name,
  )
  const cpnj = finder && finder.cnpj ? finder.cnpj : ''
  return cpnj
}

export function getNameByParam(id: string, arr: any[], param: string) {
  if (!id || !arr?.length) return ''
  const finder = arr.find((item) => item[param] === id)
  return finder.nome
}

export function getTypeVehicle(lightVehicle: boolean, heavyVehicle: boolean) {
  if (!lightVehicle && !heavyVehicle) return

  const types = [lightVehicle, heavyVehicle]

  if (types.every((type) => type === true)) return 'Leve/Pesado'
  if (lightVehicle) return 'Leve'
  return 'Pesado'
}

export function getTypeVehicleObj() {
  return Object.values(TYPE_OF_VEHICLES).map((item, index) => ({
    id: ++index,
    label: item,
  }))
}

export function getTypeVehicleSelected(type: string) {
  const list = getTypeVehicleObj()
  const finder = (label: string) => list.find((item) => item.label === label)

  switch (type) {
    case 'Leve':
      return [finder('Leve')]
    case 'Pesado':
      return [finder('Pesado')]
    default:
      return list
  }
}

export const formatInspectionPhotoLabel = (nome: string, tipo: number | string) => {
  if (!tipo || !nome) return ''
  if (typeof tipo === 'string') {
    return ` ${nome} ${tipo !== ETipoFotoVistoria[ETipoFotoVistoria.Imagem] ? `(${tipo})` : ''}`
  }
  return `${nome} ${ETipoFotoVistoria.Imagem !== tipo ? ` (${ETipoFotoVistoria[tipo]})` : ''}`
}

export function mapPhotoSections(itens: IPhotoFlowSection[]): IPhotoFlowTemp[] {
  return itens.map((item) => ({
    id: item.id,
    image: item.nomeImagem,
    name: item.nome,
    totalPhotos: item.totalFotos,
    totalRequiredPhotos: item.totalFotosObrigatorio,
    fotos: item.fotos,
    parametrizacaoSecaoFotoId: item.parametrizacaoSecaoFotoId,
  }))
}